import type { LookupCepUseCase } from '@/application/port/in/CepUseCase';
import type { CepGateway } from '@/application/port/out/CepGateway';
import type { EnderecoResolvido } from '@/domain/model/Endereco';

export class LookupCepUseCaseImpl implements LookupCepUseCase {
  constructor(private readonly gateway: CepGateway) {}

  execute(cep: string): Promise<EnderecoResolvido | null> {
    const digits = cep.replace(/\D/g, '');
    if (digits.length !== 8) return Promise.resolve(null);
    return this.gateway.lookup(digits);
  }
}
